import Vue from 'vue';
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(BootstrapVue)
Vue.config.productionTip = false;

import VueTransmit from "vue-transmit";
Vue.use(VueTransmit)

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo)

import VuePdf from "vue-pdf";
Vue.use(VuePdf)

import VuePdfPrint from "vue-pdf-print";
Vue.use(VuePdfPrint)


import VueCordova from 'vue-cordova'
Vue.use(VueCordova)

import Axios from 'axios';
Vue.use(Axios)

export const bus = new Vue();

Vue.config.productionTip = false


import VueConfirmDialog from 'vue-confirm-dialog/src'
Vue.use(VueConfirmDialog)

new Vue({
  render: h => h(App),
}).$mount('#app')


document.addEventListener('deviceready', function () {
    // cordova.plugins.printer is now available
    /*if(window.cordova){
        //add deviceready event to start app
        window.cordova.plugins.printer.print("Hello\nWorld!")
    } else {
        alert('non')
        //call starting function
    }*/
    console.log(window.cordova.file);
}, false);